export default __webpack_public_path__ + "assets/models/c5fdfb0925b8e940a9f0c097d31c8098.glb";